export class HttpResponseError extends Error {
  constructor(message, { status, data } = {}) {
    super(message)
    this.name = 'HttpResponseError'
    this.status = status
    this.data = data
  }
}

export function isHttpSuccessStatus(status) {
  return typeof status === 'number' && status >= 200 && status < 300
}

export function isHttpNoContentStatus(status) {
  return status === 204 || status === 205
}

export function isEmptyHttpResponseData(data) {
  return data === '' || data === null || data === undefined
}

export function resolveHttpResponseData(response, options = {}) {
  const { allowEmpty = true, emptyValue = null } = options

  if (!response) {
    if (allowEmpty) {
      return emptyValue
    }

    throw new HttpResponseError('Missing HTTP response')
  }

  const { status, data } = response

  if (!isHttpSuccessStatus(status)) {
    throw new HttpResponseError(`Unexpected HTTP status ${status}`, { status, data })
  }

  if (isHttpNoContentStatus(status) || (allowEmpty && isEmptyHttpResponseData(data))) {
    return emptyValue
  }

  return data
}

export function resolveHttpResponseListData(response, options = {}) {
  const emptyValue = options.emptyValue ?? []
  const data = resolveHttpResponseData(response, {
    ...options,
    emptyValue,
  })

  if (data === null || data === undefined) {
    return emptyValue
  }

  if (Array.isArray(data)) {
    return data
  }

  if (Array.isArray(data.result)) {
    return data.result
  }

  return emptyValue
}

export function selectHttpResponseData(options = {}) {
  return function httpResponseDataSelector(response) {
    return resolveHttpResponseData(response, options)
  }
}

export function selectHttpResponseListData(options = {}) {
  return function httpResponseListDataSelector(response) {
    return resolveHttpResponseListData(response, options)
  }
}
